import React from 'react';
import PasswordField from 'components/form/password';
import validationSchema from 'validation/user/register';
import { Grid, TextField, Button, Checkbox, FormControlLabel, Divider } from 'components/ui';
import { Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { WideForm } from 'components/styles_components/form';
import { LoginLink, PrivacyPolicyLink, TermsLink, PaymentTermsLink } from 'utils/link';
import { StyledLink } from 'components/styles_components/link';
import { DividerContainer } from 'components/styles_components/container';

const RegisterForm = ({ initialValues, onSubmit, processing, children }) => {
  const intl = useIntl();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema(intl)}
      onSubmit={onSubmit}
    >
      {({ errors, touched, handleSubmit, values, handleChange, handleBlur, isValid }) => (
        <WideForm onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="dense"
            id="email"
            name="email"
            label={intl.formatMessage({ id: 'user.email' }) + ' *'}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.email && Boolean(errors.email)) || undefined}
            helperText={touched.email && errors.email}
          />
          <PasswordField
            fullWidth
            margin="dense"
            id="password"
            name="password"
            label={intl.formatMessage({ id: 'user.password' }) + ' *'}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.password && Boolean(errors.password)) || undefined}
            helperText={touched.password && errors.password}
          />
          <FormControlLabel
            sx={{ mb: 2 }}
            label={
              <FormattedMessage
                id="user.privacy_policy_accepted"
                values={{
                  a: (chunk) => (
                    <StyledLink key="privacy" to={PrivacyPolicyLink()}>
                      {chunk}
                    </StyledLink>
                  ),
                }}
              />
            }
            control={
              <Checkbox
                margin="dense"
                id="privacyPolicyAccepted"
                name="privacyPolicyAccepted"
                checked={values.privacyPolicyAccepted}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  (touched.privacyPolicyAccepted && Boolean(errors.privacyPolicyAccepted)) ||
                  undefined
                }
              />
            }
          />
          <FormControlLabel
          sx={{ mb: 2 }}
            label={
              <FormattedMessage
                id="user.terms_accepted"
                values={{
                  a: (chunk) => (
                    <StyledLink key="terms" to={TermsLink()}>
                      {chunk}
                    </StyledLink>
                  ),
                  b: (chunk) => (
                    <StyledLink key="payment" to={PaymentTermsLink()}>
                      {chunk}
                    </StyledLink>
                  ),
                }}
              />
            }
            control={
              <Checkbox
                id="termsAccepted"
                name="termsAccepted"
                checked={values.termsAccepted}
                onChange={handleChange}
                onBlur={handleBlur}
                error={(touched.termsAccepted && Boolean(errors.termsAccepted)) || undefined}
              />
            }
          />
          {children}
          <Button
            sx={{ mt: 1 }}
            fullWidth
            disabled={processing || !isValid}
            color="primary"
            variant="contained"
            type="submit">
            <FormattedMessage id="button.register" />
          </Button>
          <DividerContainer />
          <Divider>
            <FormattedMessage id="auth.register.account" />
          </Divider>
          <DividerContainer />
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <StyledLink to={LoginLink()}>
              <FormattedMessage id="button.login" />
            </StyledLink>
          </Grid>
        </WideForm>
      )}
    </Formik>
  );
};

export default RegisterForm;
